module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Blauen_BL-0e02af40552a57b296d48f6c8c3fc32a.svg";